/**
 * Callable handleSolicitudDuplicateEmailAgent: precheck / finalize rechazo por email duplicado en Auth.
 */

import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../../../firebase';

export const DUPLICATE_EMAIL_CODE = 'EMAIL_ALREADY_EXISTS';

/**
 * @param {{ operation: 'precheck_before_activation' | 'finalize_after_client_auth_error', collectionName: string, solicitudId: string }} payload
 * @returns {Promise<{
 *   ok?: boolean,
 *   handled?: boolean,
 *   code?: string,
 *   message?: string,
 *   solicitudEstado?: string,
 *   emailNotificationQueued?: boolean,
 *   alreadyRejected?: boolean,
 *   emailExists?: boolean
 * }>}
 */
export async function handleSolicitudDuplicateEmailAgent(payload) {
  const fn = httpsCallable(getFunctions(app), 'handleSolicitudDuplicateEmailAgent');
  const res = await fn(payload);
  return res.data || {};
}
